import React from "react";
import "./styles.css";

const MicIcon = ({ handleClick, isActive }) => {
  return (
    <a className="audio-icon-anchor" onClick={handleClick}>
      <svg
        className="audio-svg-container element-icon"
        width="100%"
        height="100%"
        viewBox="0 0 512 512"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlSpace="preserve"
        xmlnsserif="http://www.serif.com/"
      >
        <g transform="matrix(1.79021,0,0,1.79021,53.7063,19.6923)">
          <circle className={`audio-icon-circle ${isActive ? "active" : ""}`} cx="113" cy="132" r="143" />
        </g>
        <g transform="matrix(14.9048,0,0,14.9048,77.1429,84.5952)">
          <path
            className="icon-el-path"
            d="M10.586,3.586C10.961,3.211 11.47,3 12,3C12.53,3 13.039,3.211 13.414,3.586C13.789,3.961 14,4.47 14,5L14,10C14,10.53 13.789,11.039 13.414,11.414C13.039,11.789 12.53,12 12,12C11.47,12 10.961,11.789 10.586,11.414C10.211,11.039 10,10.53 10,10L10,5C10,4.47 10.211,3.961 10.586,3.586ZM12,1C10.939,1 9.922,1.421 9.172,2.172C8.421,2.922 8,3.939 8,5L8,10C8,11.061 8.421,12.078 9.172,12.828C9.922,13.579 10.939,14 12,14C13.061,14 14.078,13.579 14.828,12.828C15.579,12.078 16,11.061 16,10L16,5C16,3.939 15.579,2.922 14.828,2.172C14.078,1.421 13.061,1 12,1ZM6,10C6,9.448 5.552,9 5,9C4.448,9 4,9.448 4,10C4,12.122 4.843,14.157 6.343,15.657C7.606,16.92 9.247,17.717 11,17.937L11,20L8,20C7.448,20 7,20.448 7,21C7,21.552 7.448,22 8,22L16,22C16.552,22 17,21.552 17,21C17,20.448 16.552,20 16,20L13,20L13,17.937C14.753,17.717 16.394,16.92 17.657,15.657C19.157,14.157 20,12.122 20,10C20,9.448 19.552,9 19,9C18.448,9 18,9.448 18,10C18,11.591 17.368,13.117 16.243,14.243C15.117,15.368 13.591,16 12,16C10.409,16 8.883,15.368 7.757,14.243C6.632,13.117 6,11.591 6,10Z"
          />
        </g>
      </svg>
      <div className="audio-tooltip">
        <p>{isActive ? "Deactivate microphone" : "Voice mode"}</p>
        <div className="triangle"></div>
      </div>
    </a>
  );
};
export default MicIcon;
